"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DISMISS_NOTIFICATION = void 0;
var DISMISS_NOTIFICATION = 'WEB_CHAT/DISMISS_NOTIFICATION';
exports.DISMISS_NOTIFICATION = DISMISS_NOTIFICATION;

function dismissNotification(id) {
  return {
    type: DISMISS_NOTIFICATION,
    payload: {
      id: id
    }
  };
}

var _default = dismissNotification;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJESVNNSVNTX05PVElGSUNBVElPTiIsImRpc21pc3NOb3RpZmljYXRpb24iLCJpZCIsInR5cGUiLCJwYXlsb2FkIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvZGlzbWlzc05vdGlmaWNhdGlvbi5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBESVNNSVNTX05PVElGSUNBVElPTiA9ICdXRUJfQ0hBVC9ESVNNSVNTX05PVElGSUNBVElPTic7XG5cbmZ1bmN0aW9uIGRpc21pc3NOb3RpZmljYXRpb24oaWQpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBESVNNSVNTX05PVElGSUNBVElPTixcbiAgICBwYXlsb2FkOiB7IGlkIH1cbiAgfTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgZGlzbWlzc05vdGlmaWNhdGlvbjtcblxuZXhwb3J0IHsgRElTTUlTU19OT1RJRklDQVRJT04gfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsSUFBTUEsb0JBQW9CLEdBQUcsK0JBQTdCOzs7QUFFQSxTQUFTQyxtQkFBVCxDQUE2QkMsRUFBN0IsRUFBaUM7RUFDL0IsT0FBTztJQUNMQyxJQUFJLEVBQUVILG9CQUREO0lBRUxJLE9BQU8sRUFBRTtNQUFFRixFQUFFLEVBQUZBO0lBQUY7RUFGSixDQUFQO0FBSUQ7O2VBRWNELG1CIn0=